import { ShareType } from "@warda/library-ui/interfaces";
import { PRODUCT_ID } from "../constants/keys";
import apiUrls from "./apiUrlsJsonStore";
import { fetchCookieJwtWithRefreshToken } from "./fetchCookieJwt";
import { PreAggregateTypeJsonstoreContext, } from "../constants/userpref";
const application = PRODUCT_ID;
const convertJSPref = (p) => {
    return {
        id: p.id,
        version: p.version || 0,
        ownerId: p.owner,
        payload: JSON.parse(p.payload),
        created: new Date(p.createdAt).getTime(),
        updated: new Date(p.editedAt).getTime(),
        shareType: p.shareObsolete === undefined || p.shareObsolete === null
            ? ShareType.PRIVATE
            : p.shareObsolete
                ? ShareType.SHARE_OBS
                : ShareType.SHARE_UPD,
    };
};
const convertJSPrefMap = (prefs) => {
    const res = Object.keys(prefs).reduce((acc, key) => {
        acc[key] = prefs[key].map(convertJSPref);
        return acc;
    }, {});
    return res;
};
export const delJSPref = async (context, preferenceId) => {
    const { url, method } = apiUrls.delJsonstorePref;
    await fetchCookieJwtWithRefreshToken({
        url: url(),
        method,
        jsonBody: {
            application,
            context,
            preferenceId,
        },
    });
};
export const addJSPref = async (context, payload) => {
    const { url, method } = apiUrls.addJsonstorePref;
    const res = await fetchCookieJwtWithRefreshToken({
        url: url(),
        method,
        jsonBody: {
            application,
            context,
            payload: JSON.stringify(payload),
        },
    });
    return convertJSPref(res);
};
export const putJSPref = async (context, preferenceId, payload, version, sharetype) => {
    const { url, method } = apiUrls.putJsonstorePref;
    const res = await fetchCookieJwtWithRefreshToken({
        url: url(),
        method,
        jsonBody: {
            application,
            context,
            preferenceId,
            payload: JSON.stringify(payload),
            shareObsolete: !sharetype || sharetype === ShareType.PRIVATE
                ? undefined
                : sharetype === ShareType.SHARE_OBS,
        },
    });
    return convertJSPref({ ...res, version });
};
export const getJSPref = async (contexts) => {
    const { url, method } = apiUrls.getJsonstorePref;
    const res = await fetchCookieJwtWithRefreshToken({
        url: url(contexts, application),
        method,
    });
    return convertJSPrefMap(res);
};
const checkMngSetsInconsistencies = (items, mngSets, ownerId) => {
    const ids = new Set(items.map((i) => i.id));
    return mngSets.map((s) => ({
        ...s,
        ownerId: s.ownerId || ownerId,
        payload: {
            ...s.payload,
            items: s.payload.items.filter((i) => ids.has(i === null || i === void 0 ? void 0 : i.id)),
        },
    }));
};
export const getJSPrefMngSets = async (ownerId, confs) => {
    const jsSets = await getJSPref(confs.map((c) => c[0]));
    return confs.map((c) => checkMngSetsInconsistencies(c[1], jsSets[c[0]], ownerId));
};
export const getJSPrefMngSetsAreaProducts = async (ownerId, confs) => {
    // Remove this function after December 2025 in favor of getJSPrefMngSets
    let newSets = await getJSPrefMngSets(ownerId, confs);
    let modalInfo = undefined;
    if (newSets.flat().length === 0) {
        // First time migration from old contexts to new ones
        const oldContexts = [
            PreAggregateTypeJsonstoreContext.productsSetsColumns,
            PreAggregateTypeJsonstoreContext.productsSetsFilters,
            PreAggregateTypeJsonstoreContext.productsSetsDetails,
        ];
        const oldSets = await getJSPrefMngSets(ownerId, [
            [oldContexts[0], confs[0][1]],
            [oldContexts[1], confs[1][1]],
            [oldContexts[2], confs[2][1]],
        ]);
        // Migrate sets from old contexts to new ones and remove old sets
        await Promise.all(oldSets.map((sets, idx) => Promise.all(sets.map(async (set) => {
            const newSet = await onCreateSet(confs[idx][0], set.payload);
            if (set.shareType !== ShareType.PRIVATE) {
                await onSharedUpsert(confs[idx][0], newSet.id);
            }
            await onRemoveSet(oldContexts[idx], set.id);
        }))));
        newSets = await getJSPrefMngSets(ownerId, confs);
        if (oldSets.flat().length > 0) {
            // qui apro un allert, vedi commento:
            // https://wardafactory.atlassian.net/browse/SEECOMM-8653?focusedCommentId=110008
            modalInfo = {
                open: true,
                title: "⚡ Important Updates to Sets",
                value: [
                    "We’ve improved how Columns, Filters, and Detail Sets are handled in the Products section.",
                    "To proceed, please reselect both the active set and the default set for each level.",
                ],
            };
        }
    }
    return [newSets, modalInfo];
};
export const onCreateSet = async (context, setPayload) => {
    const res = await addJSPref(context, setPayload);
    return res;
};
export const onRemoveSet = async (context, setId) => {
    await delJSPref(context, setId);
};
export const onUpdateSet = async (context, set) => {
    const setUpdated = await putJSPref(context, set.id, set.payload, set.version, set.shareType);
    return setUpdated;
};
export const onSharedUpsert = async (context, setId) => {
    const { url, method } = apiUrls.upsertJsonstoreShared;
    await fetchCookieJwtWithRefreshToken({
        url: url(),
        method,
        jsonBody: {
            application,
            context,
            preferenceId: setId,
        },
    });
};
export const onSharedRemove = async (context, setId) => {
    const { url, method } = apiUrls.deleteJsonstoreShared;
    await fetchCookieJwtWithRefreshToken({
        url: url(),
        method,
        jsonBody: {
            application,
            context,
            preferenceId: setId,
        },
    });
};
export const getItemsShared = async (context) => {
    const { url, method } = apiUrls.getJsonstoreShared;
    const res = await fetchCookieJwtWithRefreshToken({
        url: url(context, application),
        method,
    });
    return convertJSPrefMap(res)[context];
};
